/*       */
import React from 'react';
import styled from 'styled-components';
import { Divider } from '@mic3/platform-ui';

import { name, label, placeholder } from 'app/utils/designer/form/settings/common/commonBase';
import { multiple, includeDisabledUsers, filterBy, excludeBy, orderBy } from 'app/utils/designer/form/settings/common/commonGeneral';
import { onLoad, onChange, isVisible, isDisabled } from 'app/utils/designer/form/settings/common/commonEvents';
import { help } from 'app/utils/designer/form/settings/common/commonHelpers';
import { required, classRequired, readOnly } from 'app/utils/designer/form/settings/common/commonValidation';
import { flexGrow } from 'app/utils/designer/form/settings/common/commonStyles';


const CompactDivider = styled(Divider)`
    margin: -2px -4px -10px -4px !important;
    width: calc(100% + 8px) !important;
`;

const CompactDividerComponent = () => <CompactDivider />;



const panels = settingsValues => [
    {
        header: 'Base',
        children: [name, label, placeholder],
    },
    {
        header: 'General',
        children: [
            includeDisabledUsers,
            { type: 'custom', properties: { name: 'includeDisabledUsersDivider', Component: CompactDividerComponent, noBackground: true, } },
            multiple,
            filterBy,
            excludeBy,
            orderBy,
        ],
    },
    {
        header: 'Events',
        children: [onLoad, onChange, isVisible, settingsValues?.viewType !== 'class' && isDisabled].filter(Boolean),
    },
    {
        header: 'Validation',
        children: [settingsValues?.viewType !== 'class' ? required : classRequired, settingsValues?.viewType === 'class' && readOnly].filter(Boolean),
    },
    {
        header: 'Styles',
        children: [flexGrow],
    },
    {
        header: 'Helpers',
        children: [help],
    },
];

export default {
    defaults: { serialize: true, withDefault: true },
    panels: settingValues => panels(settingValues),
};
